import { clsx } from 'clsx';
import { Rating } from '@/components/features/Rating/Rating';
import {
  ShowMoreButtonWrapper,
} from '@/components/pages/TestimonialsPage/Testimonials/TestimonialItem/ShowMoreButtonWrapper/ShowMoreButtonWrapper';
import { ITestimonialItem } from '@/api/testimonials/testimonials.types';
import { getFullName } from '@/utils/strings';
import { dateForFrontend } from '@/utils/dates';
import { IWithClassname } from '@/models/common';
import s from './TestimonialItem.module.scss';

interface Props extends IWithClassname {
  testimonial: ITestimonialItem;
  abbreviated?: boolean;
  forMainPage?: boolean;
}

const dateOpts: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
};

export const TestimonialItem = ({ testimonial, abbreviated, forMainPage, className }: Props) => {
  const specialisations = testimonial.doctor?.specialisations?.reduce((acc, curr, i) => {
    return i === 0 ? `${curr.specialisation?.title}` : `${acc}, ${curr.specialisation?.title}`;
  }, '');

  return (
    <div className={clsx(s.item, className)}>
      <div className={s.item__head}>
        <div>{testimonial.testimonial_type}:</div>
        <div>{dateForFrontend(testimonial.publication_date, dateOpts)}</div>
      </div>
      <div className={s.item__name}>
        {testimonial?.doctor ? getFullName(testimonial?.doctor, true) : ''} {specialisations && `(${specialisations})`}
      </div>
      {/*<div className={clsx(s.item__text, { [s.item__text_cropped]: abbreviated })}>{testimonial.text}</div>*/}
      <div
        className={clsx(s.item__text, { [s.item__text_cropped]: abbreviated })}
        dangerouslySetInnerHTML={{ __html: testimonial.text }}
      />
      <div className={s.item__scoreWrapper}>
        <div className={s.item__score}>
          <Rating score={testimonial.score} />
          <span className={s.item__name}>{testimonial.author_name}</span>
        </div>
        {abbreviated && forMainPage && <ShowMoreButtonWrapper testimonial={testimonial} />}
      </div>
      {testimonial.response_date && testimonial.admin_response && !forMainPage && (
        <div className={s.item__answer}>
          <div className={s.item__head}>
            <div>Ответ клиники:</div>
            <div>{dateForFrontend(testimonial.response_date, dateOpts)}</div>
          </div>
          <div
            className={clsx(s.item__text, { [s.item__text_cropped]: abbreviated })}
             dangerouslySetInnerHTML={{ __html: testimonial.admin_response }}
          />
        </div>
      )}
      {abbreviated && !forMainPage && <ShowMoreButtonWrapper testimonial={testimonial} className={s.item__showMore} />}
    </div>
  );
};